import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Spinner } from 'reactstrap';
import api from '../services/api';
import Header from '../components/public/Header';
import Footer from '../components/public/Footer';
import LeagueRegistrationForm from '../components/public/LeagueRegistrationForm';

const LeagueRegistration = () => {
    const { guid } = useParams();
    const navigate = useNavigate();
    const [league, setLeague] = useState(null);
    const [organization, setOrganization] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        document.title = "League Registration - Reserve2Day";

        const fetchData = async () => {
            try {
                // Fetch organization details
                const orgResponse = await api.get('/get-org-details/');
                setOrganization(orgResponse.data);

                // Fetch league by GUID
                const leagueResponse = await api.get(`/leagues/by-guid/${guid}/`);
                setLeague(leagueResponse.data);
            } catch (err) {
                console.error('Error loading league:', err);
                setError(err.response?.status === 404 ? 'League not found' : 'Failed to load league details');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [guid]);

    if (loading) {
        return (
            <>
                <Header organization={organization} showBanner={false} />
                <Container className="text-center mt-5">
                    <Spinner color="primary" />
                    <p className="mt-3">Loading league registration...</p>
                </Container>
                <Footer />
            </>
        );
    }

    if (error || !league) {
        return (
            <>
                <Header organization={organization} showBanner={false} />
                <Container className="text-center mt-5">
                    <h4>{error || 'League not found'}</h4>
                    <p className="text-muted">The league you're looking for doesn't exist or is no longer available.</p>
                    <button 
                        className="btn btn-outline-dark mt-3" 
                        onClick={() => navigate('/')}
                    >
                        Go Home
                    </button>
                </Container>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header organization={organization} showBanner={false} />
            <LeagueRegistrationForm 
                league={league} 
                organization={organization}
            />
            <Footer />
        </>
    );
};

export default LeagueRegistration;
